import { render } from '@testing-library/react';
import React from 'react';

const baseUrl = process.env.NODE_ENV === 'development' ? 'https://seed.nih.gov/' : '';

const renderProp = (prop, label) => {
  if (prop) {
    return (
      <div>
        <span className='body-label'>{label}</span>
        {prop}
      </div>
    );
  }
}

const renderEvents = (props) => {
  if (props.company.events && props.company.events.length > 0) {
    return (
      <div>
        <span className='body-label'>Showcase Events:</span>
        {props.company.eventsToString.join(", ")}
      </div>
    );
  }
}

const renderDistrict = (props) => {
  if (props.company.district) {
    return <span>-{props.company.district}</span>
  }
}

const renderTech = (tech) => {
  if (tech && tech !== '') {
    return (
      <div className='technology'>
        Tech Type: {tech.replace(/\|/g, ' | ')}
      </div>
    );
  }
}

  
function Card(props) {
  return (
    <a className='card' href={props.company.link}>
      { props.company.logo ? 
        <div className='card-logo'>
          <img src={`${baseUrl}${props.company.logo}`}></img>
        </div>
        :
        <div className='card-title'>
          <h3 dangerouslySetInnerHTML={{__html: props.company.title}}></h3>
        </div>
      }
      <div className='card-body'>
        {/*
        <div className='technology'>{props.company.technology_type}</div>
        <div>
          <span className='body-label'>Contact:</span>
          {props.company.contact_name}
        </div>
        <div>
          <span className='body-label'>State-District:</span>
          {props.company.state}{ renderDistrict(props) }
        </div>
        */}
        { renderTech(props.company.technology_type) }
        { renderEvents(props) }
        { renderProp(props.company.funding_from, 'Funding:') }
      </div>      
    </a>
  );
};

export default Card;